module.exports = __webpack_public_path__ + "static/media/60---az.a97767cb.jpeg";